import React from "react"

import HeroBackground from "../images/hero/hero-background.jpg"
import Image from "../components/image"

const Hero = () => {
  return (
    <header className="wash-navy" id="hero">
      <div id="heroWedge">
        <div id="heroStock">
          <Image
            name="hero-foreground"
            alt=""
            style={{
              zIndex: 5,
              position: "absolute",
              bottom: 0,
              right: "1px",
              width: "100%",
            }}
          />

          <div
            id="heroStockBackground"
            style={{
              zIndex: 4,
              height: "100%",
              width: "100%",
              background: `#8d80f1 url(${HeroBackground})`,
              backgroundAttachment: "fixed",
              backgroundSize: "35vw 35vw",
              borderRadius: "50%",
            }}
          ></div>
        </div>
      </div>

      <div id="heroText">
        <h1>Meeting Patients Where&nbsp;They&nbsp;Are</h1>
        <h3 className="is-violet">
          The&nbsp;Value&nbsp;of Bringing&nbsp;Healthcare&nbsp;Home
        </h3>

        <p className="is-royal-p1">Industry Status Report, June 2021</p>
      </div>
    </header>
  )
}

export default Hero
